import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { SITE_URL, getSeoForPath } from "../lib/site";

function upsertMeta(selector: string, attributes: Record<string, string>) {
  let element = document.head.querySelector(selector) as HTMLMetaElement | null;

  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element!.setAttribute(key, value);
  });
}

function upsertLink(selector: string, attributes: Record<string, string>) {
  let element = document.head.querySelector(selector) as HTMLLinkElement | null;

  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element!.setAttribute(key, value);
  });
}

export default function RouteSeo() {
  const location = useLocation();

  useEffect(() => {
    const seo = getSeoForPath(location.pathname);
    const imageUrl = `${SITE_URL}/LogoChichawasi.png`;

    document.documentElement.lang = "es";
    document.title = seo.title;

    upsertLink('link[rel="canonical"]', {
      rel: "canonical",
      href: seo.canonical,
    });

    upsertMeta('meta[name="description"]', {
      name: "description",
      content: seo.description,
    });

    upsertMeta('meta[name="robots"]', {
      name: "robots",
      content: "index,follow",
    });

    upsertMeta('meta[property="og:title"]', {
      property: "og:title",
      content: seo.title,
    });

    upsertMeta('meta[property="og:description"]', {
      property: "og:description",
      content: seo.description,
    });

    upsertMeta('meta[property="og:type"]', {
      property: "og:type",
      content: "website",
    });

    upsertMeta('meta[property="og:url"]', {
      property: "og:url",
      content: seo.canonical,
    });

    upsertMeta('meta[property="og:image"]', {
      property: "og:image",
      content: imageUrl,
    });

    upsertMeta('meta[property="og:image:alt"]', {
      property: "og:image:alt",
      content: "Logo de Chichawasi",
    });

    upsertMeta('meta[property="og:locale"]', {
      property: "og:locale",
      content: "es_PE",
    });

    upsertMeta('meta[name="twitter:card"]', {
      name: "twitter:card",
      content: "summary_large_image",
    });

    upsertMeta('meta[name="twitter:title"]', {
      name: "twitter:title",
      content: seo.title,
    });

    upsertMeta('meta[name="twitter:description"]', {
      name: "twitter:description",
      content: seo.description,
    });

    upsertMeta('meta[name="twitter:image"]', {
      name: "twitter:image",
      content: imageUrl,
    });
  }, [location.pathname]);

  return null;
}
